<mat-form-field *ngIf="!this.multiline" style="width: 100%;" [formGroup]="form">
  <span *ngIf="this.matPrefix === true">{{item.matPrefixText | translate}}&nbsp;</span>
  <input matInput [formControlName]="item.name" [maxlength]="item.maxlength" [placeholder]="item.label"
    [required]="item.required"
    [type]="inputType" [style]="this.inputWidthPercent > 0 ? 'width:'+this.inputWidthPercent+'%;':''"
    (change)="onChange($event)">
  <span *ngIf="this.matSuffix === true">{{item.matSuffixText | translate}}&nbsp;</span>
  <button #iconButton *ngIf="item.icon" color="primary" mat-icon-button type="button" (click)="onClick($event)">
    <mat-icon>{{item.icon_type}}</mat-icon>
  </button>
  <ng-container *ngFor="let validation of item.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="form.get(item.name).hasError(validation.name)">{{validation.message | translate}}</mat-error>
  </ng-container>
</mat-form-field>

<mat-form-field *ngIf="this.multiline" style="width: 100%" [formGroup]="form">
  <mat-label>{{item.label}}</mat-label>
  <textarea matInput [formControlName]="item.name" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" [style]="this.inputWidthPercent > 0 ? 'width:'+this.inputWidthPercent+'%;':''"
    (change)="onChange($event)">
    {{item.value}}
  </textarea>
  <button #iconButton *ngIf="item.icon" color="primary" mat-icon-button type="button" (click)="onClick($event)">
    <mat-icon>{{item.icon_type}}</mat-icon>
  </button>
</mat-form-field>